/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GoOptionInternalOptionInterval
 */
export interface GoOptionInternalOptionInterval {
  /**
   *
   * @type {number}
   * @memberof GoOptionInternalOptionInterval
   */
  value: number
  /**
   *
   * @type {number}
   * @memberof GoOptionInternalOptionInterval
   */
  max: number
  /**
   *
   * @type {number}
   * @memberof GoOptionInternalOptionInterval
   */
  min: number
}

/**
 * Check if a given object implements the GoOptionInternalOptionInterval interface.
 */
export function instanceOfGoOptionInternalOptionInterval(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'value' in value
  isInstance = isInstance && 'max' in value
  isInstance = isInstance && 'min' in value

  return isInstance
}

export function GoOptionInternalOptionIntervalFromJSON(
  json: any,
): GoOptionInternalOptionInterval {
  return GoOptionInternalOptionIntervalFromJSONTyped(json, false)
}

export function GoOptionInternalOptionIntervalFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GoOptionInternalOptionInterval {
  if (json === undefined || json === null) {
    return json
  }
  return {
    value: json['Value'],
    max: json['max'],
    min: json['min'],
  }
}

export function GoOptionInternalOptionIntervalToJSON(
  value?: GoOptionInternalOptionInterval | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    Value: value.value,
    max: value.max,
    min: value.min,
  }
}
